import { Exercises } from "../enums/exercises";
import useExerciseDescriptionStructure, { Locales, SentenceVariants } from "./useExerciseDescriptionStructure";

const useExerciseDescription = () => {
    const { availableExerciseDescriptions } = useExerciseDescriptionStructure();

    function getExerciseSentences(exerciseType: Exercises, locale: Locales) {
        return availableExerciseDescriptions[exerciseType][locale];
    }

    function getDefaultDescription(exerciseType: Exercises, locale: Locales) {
        return availableExerciseDescriptions[exerciseType][locale][0][SentenceVariants.LONG_SENTENCE]; // uses index 0 as ths is the default sentence in the availableExerciseDescriptions matrix
    }

    return { getExerciseSentences, getDefaultDescription };
};

export default useExerciseDescription;
